export const black = '#000000';
export const codGray = '#121212';
export const mineShaft = '#333333';
export const emperor = '#555555';
export const boulder = '#777777';
export const dustGray = '#999999';
export const alto = '#CFCFCF';
export const mercury = '#E6E6E6';
export const wildSand = '#F4F4F4';
export const alabaster = '#F8F8F8';
export const white = '#FFFFFF'; //Teal

export const tarawera = '#09414D';
export const atoll = '#095F70';
export const blueLagoon = '#067A91';
export const bondiBlue = '#0093B2';
export const java = '#1DAFCC';
export const arendtBlue = '#65D0E5';
export const frenchPass = '#B2F2FF';
export const catskillWhite = '#E9F3F5'; //Mustard

export const pirateGold = '#F3C00E';
export const equator = '#FCCD28';
export const peach = '#FCD651';
export const varden = '#FDF3CF'; //Orange

export const oregon = '#E97A18';
export const hotCinnamon = '#FC8B27';
export const apricot = '#FD9940'; //Red

export const fairPink = '#FFEDED';
export const totemPole = '#91060A';
export const thunderBird = '#CC1D22';
export const sundown = '#FFB2B5'; //Blue

export const tealBlue = '#094A70';
export const orient = '#005789';
export const veniceBlue = '#065E91';
export const deepCerulean = '#0071B3';
export const curiousBlue = '#1D8CCC';
export const turquoiseBlue = '#65B6E6';
export const anakiwa = '#B2E2FF'; //Green

export const willowBrook = '#EAF4E7';
export const limeade = '#349106';
export const apple = '#6DBE45';
export const conifer = '#90E665';
export default {
  black,
  mineShaft,
  emperor,
  boulder,
  dustGray,
  alto,
  mercury,
  wildSand,
  white,
  tarawera,
  atoll,
  blueLagoon,
  bondiBlue,
  java,
  arendtBlue,
  frenchPass,
  catskillWhite,
  pirateGold,
  equator,
  peach,
  varden,
  oregon,
  hotCinnamon,
  apricot,
  fairPink,
  totemPole,
  thunderBird,
  sundown,
  tealBlue,
  orient,
  veniceBlue,
  deepCerulean,
  curiousBlue,
  turquoiseBlue,
  anakiwa,
  willowBrook,
  limeade,
  apple,
  conifer
};